export default "__VITE_ASSET__BFHjqq7M__"